import {
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  ProTable,
  type ActionType,
  type ProColumns,
} from "@ant-design/pro-components";
import { Button, Input, Popconfirm, Space } from "antd";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

interface ClientNote {
  id: string;
  note_header: string;
  description: string;
}

const dummyNotes: ClientNote[] = [
  {
    id: "1",
    note_header: "First Meeting Summary",
    description: "Discussed initial requirements and timelines.",
  },
  {
    id: "2",
    note_header: "Follow-up Tasks",
    description: "Client requested additional analysis by next week.",
  },
  {
    id: "3",
    note_header: "Budget Discussion",
    description: "Reviewed project cost estimates and approved phase one.",
  },
];

const ClientNotesTable: React.FC = () => {
  const actionRef = useRef<ActionType>();
  const [tableData, setTableData] = useState<ClientNote[]>(dummyNotes);
  const [searchText, setSearchText] = useState<string>("");
  const navigate = useNavigate();

  const handleDelete = (id: string) => {
    setTableData((prev) => prev.filter((note) => note.id !== id));
  };

  const filteredData = tableData.filter(
    (note) =>
      note.note_header.toLowerCase().includes(searchText.toLowerCase()) ||
      note.description.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns: ProColumns<ClientNote>[] = [
    {
      title: "Note Header",
      dataIndex: "note_header",
      key: "note_header",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            onClick={() => navigate(`/modules/clients/notes/edit/${record.id}`)}
          />
          <Popconfirm
            title="Delete this note?"
            onConfirm={() => handleDelete(record.id)}
          >
            <Button icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <ProTable<ClientNote>
        headerTitle="Client Notes"
        actionRef={actionRef}
        rowKey="id"
        columns={columns}
        dataSource={filteredData}
        search={false}
        pagination={{
          defaultPageSize: 5,
          showSizeChanger: true,
        }}
      
      />
    </div>
  );
};

export default ClientNotesTable;
